import { IDonor } from '@nkr/models/index';
import RemoteWorkupsNotBilledRow from './row';
import { TableWrapperLeftAligned } from '../styles';

interface IProps {
    list: IDonor[]
}

const RemoteWorkupsNotBilled = (props: IProps) => {
    return (
        <div style={{ height: 500, overflowY: 'scroll' }}>
            <TableWrapperLeftAligned className='table table-condensed table-striped table-bordered'>
                <thead>
                    <tr>
                        <th>Alias</th>
                        <th>Donation Date</th>
                    </tr>
                </thead>
                <tbody>
                    {props.list.map((item, index) =>
                        <RemoteWorkupsNotBilledRow
                            key={'rw-' + index}
                            index={index}
                            data={item}
                        />
                    )}
                </tbody>
            </TableWrapperLeftAligned>
        </div>
    )
};

export default RemoteWorkupsNotBilled;